const SlideNumber = function SlideNumber(Splide, Components) {
  const { track } = Components.Elements;

  let elm;

  function mount() {
    elm = document.createElement("div");
    elm.classList.add("g-splide-numbers");

    track.parentElement.insertBefore(elm, track.previousSibling);

    update();
    Splide.on("move", update);
  }

  function update() {
    elm.textContent = `${Splide.index + 1}/${Splide.length}`;
  }

  return {
    mount,
  };
};
